import React, { useState, useEffect } from "react";
import PasswordResetBig from "./PasswordResetBig";
import PasswordResetSmall from "./PasswordResetSmall";

// Custom hook to detect device type
function useDevice() {
	const [device, setDevice] = useState(getDeviceType());

	function getDeviceType() {
		const width = window.innerWidth;
		if (width < 768) return "mobile";
		if (width < 1024) return "tablet";
		return "desktop";
	}

	useEffect(() => {
		function handleResize() {
			setDevice(getDeviceType());
		}

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return device;
}

// Main component
export default function PasswordReset(props) {
	const device = useDevice();

	return (
		<div>
			{device === "mobile" && <PasswordResetSmall match={props.match} history={props.history} />}
			{device === "tablet" && <PasswordResetBig match={props.match} history={props.history} />}
			{device === "desktop" && <PasswordResetBig match={props.match} history={props.history} />}
		</div>
	);
}
